module.exports = __webpack_public_path__ + "media/logo.b480721f.svg";